import Logo from "../../../assets/images/mrpropfund/logo.png";
import {MdLogin, MdLogout, MdOutlineHandshake} from "react-icons/md";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {userLogout} from "../../../redux/store/services/user/store";
import {useNavigate} from "react-router";
import {ErrorToaster} from "../../../shared/toaster";
import {useTranslation} from "react-i18next";

export const MrpropfundUpperHeader = ({isTokenValid}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {t, i18n} = useTranslation();
    const profile = useSelector((state) => state.profile);

    return (
        <div className="upper-header">
            <div className="logo"><img src={Logo} alt=""/></div>
            <div className="main-header-menu-container">
                <div className="main-header-menu-top">
                    {
                        isTokenValid ?
                            <div className="main-header-menu-bottom-item" onClick={() => {
                                try {
                                    dispatch(userLogout())
                                    navigate('/signin')
                                } catch (e) {
                                    ErrorToaster({message: `There is a problem in Signing out!: ${e}`}, t)
                                }
                            }}>
                                <MdLogout size={17} color={"#fff"}/>
                                خروج از پنل
                            </div> :
                            <div className="main-header-menu-bottom-item" onClick={() => {
                                navigate('/signin')
                            }}>
                                <MdLogin size={17} color={"#fff"}/>
                                ورود به پنل
                            </div>
                    }

                    <div className="main-header-menu-bottom-item" onClick={()=>{
                        if(profile?.roles?.includes('customer'))
                            // navigate('/account-list')
                            window.location.replace(`${process.env.REACT_APP_WEBSITE_URL}/terms-and-conditions`);
                    }}>
                        <MdOutlineHandshake size={17} color={"#fff"}/>
                        قوانین و مقررات
                    </div>
                </div>
                <div className="main-header-menu-bottom">

                    <div className="main-header-menu-bottom-item" onClick={()=>{
                        window.location.href = process.env.REACT_APP_WEBSITE_URL;
                    }}>خانه</div>
                    <div className="main-header-menu-bottom-item" disabled={profile?.roles?.includes('admin')} onClick={()=>{
                        if(profile?.roles?.includes('customer'))
                            navigate('/plans')

                        if(profile?.roles?.includes('admin'))
                            ErrorToaster({message: 'دسترسی به این بخش فقط از طریق مشتریان امکان پذیر است'}, t)
                    }}>پلن ها</div>
                    <div className="main-header-menu-bottom-item" onClick={()=>{
                        window.location.href = `${process.env.REACT_APP_WEBSITE_URL}/blog`;
                    }}>مقالات</div>
                    <div className="main-header-menu-bottom-item" onClick={()=>{
                        window.location.href = `${process.env.REACT_APP_WEBSITE_URL}/about-us`;
                    }}>درباره ما</div>
                </div>
            </div>
        </div>
    )
}